export enum ENavigationType {

	google = "google",
	gouv = "gouv",
	waze = "waze"
}